import React, { createContext, useContext } from "react"
import { storage } from "../api/firebase/firebaseConfig";

const StorageContext = createContext()

export const useStorage = () => useContext(StorageContext)

export const StorageProvider = ({ children }) => {
    const value = {
        storage,
    }

    return (
        <StorageContext.Provider value={value}>
            {children}
        </StorageContext.Provider>
    )
}